import { Component, OnInit } from '@angular/core';
import { UserModel } from '../../../../authentication/models/user.model';
import { AuthenticationService } from '../../../../authentication/services/authentication.service';
import { MultiTenantService } from '../../../../authentication/services/multi-tenant.service';
import { ActiveModal } from '../../../../modals/classes/active-modal';
import { Buttons } from '../../../../modals/classes/buttons';

@Component({
    selector: 'chassis-core-tenants-modal',
    templateUrl: './tenants-modal.component.html',
    styleUrls: ['./tenants-modal.component.scss'],
})
export class TenantsModalComponent implements OnInit {

    public user: any = {};

    public tenants = [];

    constructor(protected auth: AuthenticationService, protected tenantService: MultiTenantService, protected modal: ActiveModal) {
    }

    public ngOnInit() {
        this.auth.user().subscribe((user: UserModel) => {
            this.user = user;
        });

        const buttons = this.modal.get<Buttons>('buttons');

        buttons.remove('ok');

        this.setTenantsForDropdowns(this.user.tenants);
    }

    public changeTenantScope(scope: number) {
        this.tenantService.setCurrentScope(scope);

        this.modal.close(scope);
    }

    private setTenantsForDropdowns(tenants: Array<any>) {
        this.tenants = [];

        const usedTenants = [];

        if (tenants && (tenants instanceof Array)) {
            this.iterateParentTenants(usedTenants, tenants);
        }
    }

    private iterateParentTenants(used: Array<any>, tenants: Array<any>) {
        const hasAParentTenant = tenants.filter(_tenant => _tenant.parent_id === null).length > 0;
        this.tenants           = tenants
            .map(tenant => {
                if (tenant.parent_id === null && tenant.children instanceof Array) {
                    tenant.children = tenant.children.filter(child => {
                        return tenants.find(_tenant => _tenant.id === child.id);
                    });
                }

                return tenant;
            });

        if (hasAParentTenant) {
            this.tenants = this.tenants.filter(tenant => tenant.parent_id === null);
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/partials/tenants-modal/tenants-modal.component.ts